import { useEffect } from "react";
import { appStore } from "src/framework/store/AppStore";
import { EdicaoLayoutPersonalizadoOff } from "src/components/projetos/edicao/layouts/EdicaoLayoutPersonalizadoOff";
import { ProjetosFormInicialPersonalizadoOffGrid } from "src/components/projetos/personalizados_offgrid/containers/Formulario/FormInicial";

const PAGE_TITLE = 'Clonar projeto off grid'

const ProjetosFormInicialPersonalizadoOffClonar = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])
  
  return (
    <EdicaoLayoutPersonalizadoOff clonarProjeto>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetosFormInicialPersonalizadoOffGrid />
          </div>
        </div>
      </div>
    </EdicaoLayoutPersonalizadoOff>
  );
};

export { ProjetosFormInicialPersonalizadoOffClonar };